import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Theme from '../../../utils/Theme.js';
var theme = Theme.select({
  redbrand: 'redbrand',
  mands: 'mands'
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement(React.Fragment, null, theme === 'redbrand' && React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("path", {
    d: "M16.5 6h-15C.675 6 0 6.675 0 7.5v9c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5v-9c0-.825-.675-1.5-1.5-1.5zm.3 10.5c0 .163-.137.3-.3.3h-15a.304.304 0 0 1-.3-.3v-6.3h15.6v6.3zm0-7.5H1.2V7.5c0-.163.137-.3.3-.3h15c.163 0 .3.137.3.3V9zM15 12h-3v1.2h3V12zM13.05 1.221a.306.306 0 0 1 .391.166L14.82 4.8h1.294L14.553.938a1.504 1.504 0 0 0-1.952-.829L.988 4.8h3.204l8.858-3.579z"
  })), theme === 'mands' && React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), React.createElement("g", {
    transform: "translate(0 3)",
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    strokeWidth: "1.7",
    x: ".637",
    y: ".637",
    width: "16.725",
    height: "11.187",
    rx: "2"
  }), React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M1.067 3.837h15.865v2.019H1.067z"
  }))));
};

export default SvgComponent;